module.exports = __webpack_public_path__ + "media/images/lb/180-d03d92d2d11925b07926df1c02450280.svg";